export default "__VITE_ASSET__5e53a9b5__"